import { render, staticRenderFns } from "./Ledger.vue?vue&type=template&id=753ad9d6&scoped=true"
import script from "./Ledger.vue?vue&type=script&lang=js"
export * from "./Ledger.vue?vue&type=script&lang=js"
import style0 from "./Ledger.vue?vue&type=style&index=0&id=753ad9d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753ad9d6",
  null
  
)

export default component.exports